export default "__VITE_ASSET__3367d24f__"